import { Link as CapraLink } from '@capra/core';
import { Pill } from '@capra/core';
import NextLink from 'next/link';
import styled from 'styled-components';

import type { UrlObject } from 'url';

export const Nav = styled.nav`
  --service-nav-bg: white;
  --service-nav-border: transparent;

  background: #ffffff;
  font-size: 12px;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.12);
  height: calc(100vh - 40px);
  left: 0;
  padding: 4px 8px;
  position: absolute;
  overflow-y: auto;
  top: 40px;
  width: 182px;
  z-index: 1051; /* one more than AntD menu overlay, wtf */
  align-items: flex-start;
  display: flex;
  flex-direction: column;

  .settings-item-container {
    margin-top: auto;
    width: 100%;
  }
`;

export const StyledLink = styled(CapraLink).attrs({ as: NextLink })<{ $isActive?: boolean; href: string | UrlObject }>`
  align-items: center;
  border-radius: 6px;
  color: rgb(89, 89, 89);
  cursor: pointer;
  display: flex;
  height: 26px;
  line-height: 100%; /* .ant-layout-header tries to set line height at 64px for some reason */
  padding: 0 2px 0 4px;
  width: 100%;

  ${({ $isActive }) => $isActive && `
    background-color: #ccf5f5;
    color: #024c4c;
  `}

  &:hover {
    background-color: #dae2e3;
    color: rgba(0, 0, 0, 0.85);
    div {
      svg {
        fill: rgba(0, 0, 0, 0.85);
      }
    }
  }

  &:focus-visible {
    border-radius: 2px;
  }

  div {
    svg {
      fill: rgba(0, 0, 0, 0.45);
    }
  }
`;

export const StyledList = styled.ul`
  --section-border-color: rgba(0, 0, 0, 0.04);

  padding: 8px 0;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 2px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--section-border-color);
  }

  li {
    list-style: none;
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 8px;
  width: 100%;
`;

export const PreviewTag = styled(Pill)`
  margin-right: 0;
  font-weight: normal;
  font-size: 10px;
  padding-inline: 4px;
`;
